<script lang="ts">
	import ServiceCard from "@components/ServiceCard.svelte";
	import Formatted from "@components/common/Formatted.svelte";
	import Link from "@components/common/Link.svelte";
	import Slideshow from "@components/common/Slideshow.svelte";
	import { hugeHeadingParallax } from "@utils/hugeHeadingParallax.js";
	import type { ClassValue } from "svelte/elements";
	import { iconMap } from "@core/assets/icons/iconMap.js";
	import { ButtonVariant } from "@core/schema/ButtonVariant.js";
	import { getServiceAnchor } from "@core/schema/paths/getServiceAnchor.js";
	import { getServicesSolutionsPath } from "@core/schema/paths/getServicesSolutionsPath.js";
	import { getGlobalTemplateProps } from "../../contexts/getGlobalTemplateProps.js";

	const { class: customClass }: { class?: ClassValue } = $props();
	const { tenant } = getGlobalTemplateProps();
</script>

<section class={[customClass, "full-width py-8 md:py-16 lg:py-20"]} id={getServiceAnchor(tenant)}>
	<div class="h-[1.25em] overflow-hidden relative huge-heading" use:hugeHeadingParallax>
		<Slideshow flowDirection="left" forceSlidingOnMobile forceSlidingOnHover speed={1}>
			<h2 class="text-nowrap text-cmcsecondary m-0 leading-tight pr-4">
				<Formatted text="stroke[[Navrhneme, provedeme,]] dotáhneme." />
			</h2>
			<span class="text-nowrap text-cmcsecondary m-0 leading-tight pr-4" aria-hidden="true">
				<Formatted text="stroke[[Navrhneme, provedeme,]] dotáhneme." />
			</span>
			<span class="text-nowrap text-cmcsecondary m-0 leading-tight pr-4" aria-hidden="true">
				<Formatted text="stroke[[Navrhneme, provedeme,]] dotáhneme." />
			</span>
		</Slideshow>
	</div>
	<div class="grid-container flex flex-col gap-1 md:gap-2">
		<ServiceCard
			icon={iconMap.advice}
			title="Logistické poradenství"
			description="
				Přijde vám že ve vaší logistice něco nefunguje, ale nevíte co? Podíváme se tomu na zoubek. Objevíme slabiny, snížíme
				náklady nebo nastavíme systém, který bude roky fungovat.
			"
		/>
		<ServiceCard
			icon={iconMap.box}
			title="Obalová řešení"
			description="
				Zkontrolujeme, jestli za obaly neplatíte víc, než musíte, navrhneme efektivnější obalový koncept i vizuální identitu
				nebo urychlíme proces balení. Řešíme úsporu, efektivitu i atraktivní design obalů.
			"
		/>

		<ServiceCard
			icon={iconMap["checklist-clipboard"]}
			title="Dočasné řízení logistiky"
			description="
				Náš zkušený interim manažer okamžitě převezme řízení vašeho skladu nebo celé logistiky – ať už dočasně,
				nebo do vyřešení nečekané situace. Platíte za odvedenou práci, ne za naši přítomnost.
			"
		/>
		<ServiceCard
			icon={iconMap.rolodex}
			title="Outsourcing náboru pro logistiku"
			description="
				Potřebujete rychle doplnit nebo stabilizovat logistický tým, ale nemáte s tím zkušenosti, případně vám chybí
				čas nebo kapacity? Nechte HR starosti na Commarec. Převezmeme za vás celý náborový proces, nebo jeho část.
			"
		/>
		<ServiceCard
			icon={iconMap.education}
			title="Logistické vzdělávání"
			description="
				Neustálý rozvoj kompetencí je základ. Když si u Commarec objednáte logistické vzdělávání, na míru vám připravíme praktická
				školení a workshopy pro jednotlivce i celé týmy. Žádné nudné prezentace a bezcenné certifikáty, ale důraz na zlepšení výkonu
				a doručení výsledků.
			"
		/>

		<Link
			href={getServicesSolutionsPath(tenant)}
			variant={ButtonVariant.Outlined}
			icon="arrow"
			class="inline-flex gap-11 w-fit mt-6 md:mt-14 mx-auto"
		>
			<Formatted text="Všechny služby a řešení" />
		</Link>
	</div>
</section>
